import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface TipoVehiculoItem {
  id: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

@Injectable({
  providedIn: "root",
})
export class TipoVehiculoService {
  private apiUrl = `${environment.apiUrl}/api/tipo_vehiculo`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl, { withCredentials: true });
  }
}
